import { render, staticRenderFns } from "./DossierScriptShowProperties.vue?vue&type=template&id=132758e2&scoped=true&"
import script from "./DossierScriptShowProperties.vue?vue&type=script&lang=ts&"
export * from "./DossierScriptShowProperties.vue?vue&type=script&lang=ts&"
import style0 from "./DossierScriptShowProperties.vue?vue&type=style&index=0&id=132758e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132758e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('132758e2')) {
      api.createRecord('132758e2', component.options)
    } else {
      api.reload('132758e2', component.options)
    }
    module.hot.accept("./DossierScriptShowProperties.vue?vue&type=template&id=132758e2&scoped=true&", function () {
      api.rerender('132758e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierScriptShowProperties.vue"
export default component.exports